define((require) => {
    "use strict";

    const {isNumber, isString} = require("underscore");

    const DEFAULT_BORDER_COLOR = "#000000";

    /**
     * A mixin for widgets that can be styled with border width, shadow and border radius.
     */
    return {
        /**
         * Add CSS style border width, shadow and border radius to the default common properties.
         *
         * @return {Object} A hash of CSS values mapped to property names.
         */
        defaultCSS() {
            const css = this.__super();

            // Set border
            if (this.model.get("borderWidth") > 0) {
                css.border = `${this.model.get("borderWidth")}px solid ${this.model.get("borderColor") || DEFAULT_BORDER_COLOR}`;
            } else {
                css.borderWidth = 0;
            }

            // Make sure to remove the previous shadow on re-render
            css.boxShadow = this.computeBoxShadow();

            // Set border radius
            const radius = this.model.get("radius");

            if (isNumber(radius)) {
                const borderRadius = radius * this.model.get("scale").average();
                css.borderRadius = `${borderRadius}px`;
            } else if (isString(radius)) {
                css.borderRadius = radius;
            }

            // Apply opacity...
            css.opacity = this.model.get("opacity");

            return css;
        },

        computeBoxShadow() {
            const boxShadow = this.__super();

            return boxShadow || (this.model.get("boxShadow") || "none");
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/StyleableMixin.js